"use client";

import { c as _c } from "react/compiler-runtime";
import { IconCircleCheck as CheckmarkCircleIcon } from "central-icons/IconCircleCheck";
import { IconCircleInfo as InfoIcon } from "central-icons/IconCircleInfo";
import { IconCircleX as FailedIcon } from "central-icons/IconCircleX";
import { IconExclamationTriangle as WarningIcon } from "central-icons/IconExclamationTriangle";
import { useTheme } from "next-themes";
import { Toaster } from "sonner";
export function ThemedToaster() {
  const $ = _c(4);
  const {
    resolvedTheme
  } = useTheme();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: <FailedIcon className="size-5 shrink-0 fill-red-500" />,
      info: <InfoIcon className="size-5 shrink-0 stroke-blue-500" />,
      success: <CheckmarkCircleIcon className="size-5 shrink-0 fill-green-500" />,
      warning: <WarningIcon className="size-5 shrink-0 fill-amber-500" />
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = resolvedTheme === "dark" ? "dark" : "light";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      className: "text-sm! bg-white! select-none! dark:bg-gray-200! border-gray-400! text-fg!",
      classNames: {
        icon: "mr-2!"
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1) {
    t3 = <Toaster icons={t0} position="bottom-right" theme={t1} toastOptions={t2} />;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}